import Reactions from './reactions'
import Profiles from './profiles'
import Stars from './stars'

const roots = [
  Profiles,
  Reactions,
  Stars
]

export default roots
